import React, { useEffect } from "react";
import { View } from "react-native";

type ShareWrapperProps = {
  children: (viewRef: React.RefObject<View>) => React.ReactNode;
  dependencies?: unknown[];
};

const ShareWrapper: React.FC<ShareWrapperProps> = ({
  children,
  dependencies = [],
}) => {
  const viewRef = React.useRef<View>(null);

  // force re-render when dependencies change
  const [, forceRender] = React.useState(0);

  useEffect(() => {
    forceRender(x => x + 1);
  }, dependencies);

  return <>{children(viewRef as any)}</>;
};

export default ShareWrapper;
